// removed by extract-text-webpack-plugin
module.exports = {"icon":"_1bYT5TPpRiWFNCTaRF4Olo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Link/Link.module.scss
// module id = 784
// module chunks = 0